import React from 'react';
import TableView from '../tableView';
import { BoughtProductsResult } from '../../Model/contact';
import { useTranslation } from 'react-i18next';

interface Props {
  boughtProducts: BoughtProductsResult[],
  tabulator: any,
  filterSelectOptions: {}
}

const ProductsTable = ({
  filterSelectOptions,
  boughtProducts,
  tabulator
}: Props) => {
  const { t } = useTranslation();
  const boughtProductsColumns = [
    {
      title: t('PRODUCT_TYPE'),
      field: 'productTypeCode',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    },
    {
      title: t('NAME'),
      field: 'productTypeFriendlyName',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    },
    {
      title: t('TYPE_ID'),
      field: 'productTypeId',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    },
    {
      title: t('QUANTITY_BOUGHT'),
      field: 'quantityBought',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    },
    {
      title: t('QUANTITY_REFUNDED'),
      field: 'quantityRefunded',
      sorter: 'string',
      headerFilter: 'input',
      editorParams: filterSelectOptions,
      headerFilterParams: filterSelectOptions
    }
  ];

  return <>  {
    boughtProducts.length > 0
      ? <TableView
        t={t}
        ref={tabulator}
        data={boughtProducts}
        columns={boughtProductsColumns}
        id={'boughtProduct-list'} />
      : <p className='noData'>{t('NO_DATA')}</p>
  }
  </>;
};

export default ProductsTable;